import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const AdminPage = lazy(() => import("./components/AdminPage"));
const JoinPage = lazy(() => import("./components/JoinPage"));

const root = document.getElementById("root");
if (!root) throw new Error("no #root element");

const pathname = window.location.pathname;
const isAdmin = pathname === "/admin";
const joinMatch = pathname.match(/^\/s\/([A-Za-z0-9_-]+)$/);

createRoot(root).render(
  <StrictMode>
    {isAdmin ? (
      <Suspense fallback={null}>
        <AdminPage />
      </Suspense>
    ) : joinMatch && joinMatch[1] ? (
      <Suspense fallback={null}>
        <JoinPage inviteToken={joinMatch[1]} />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
